import { render, staticRenderFns } from "./ApmsRegToolReturnRecord.vue?vue&type=template&id=542bce84&scoped=true&"
import script from "./ApmsRegToolReturnRecord.vue?vue&type=script&lang=js&"
export * from "./ApmsRegToolReturnRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542bce84",
  null
  
)

export default component.exports